// Externe Bibliotheken
import React, { useState } from 'react';

// Interne Module
import * as storage from '@/_helper/storage';
import { COMPANY } from '@/_config/constants';
import { utcToDateString } from '@/_helper/dateValidator';

// Komponenten
import Header from '@/comp/header/Header';
import Footer from '@/comp/footer/Footer';
import Button from '@/comp/button/button';

// Styles
import './privacy-policy.scss';

export const PrivacyPolicy = () => {
    const [consentData, setConsentData] = useState({
        cookieData: null,
        uuid: '',
        dateString: '',
        enabledSettings: '',
    });
    const [init, setInit] = useState(false);
    const cookieName = window.$cookieName;

    const setConsentDataFromCookie = () => {
        const cookieData = window.$gtmTracking.getCookie(cookieName);
        let enabledSettings = '';

        if (cookieData) {
            enabledSettings += 'Notwendige';
            if (cookieData?.analytics_storage === 'granted') {
                enabledSettings += ', Analytische';
            }

            if (cookieData?.ad_storage === 'granted') {
                enabledSettings += ', Marketing';
            }

            if (cookieData?.ad_user_data === 'granted') {
                enabledSettings += ', Werbung';
            }

            if (cookieData?.ad_personalization === 'granted') {
                enabledSettings += ', Personalisiert';
            }

            setConsentData({
                cookieData: cookieData,
                uuid: cookieData?.stamp,
                dateString:
                    utcToDateString(cookieData?.utc, {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                    }) + ' Uhr',
                enabledSettings: enabledSettings,
            });
            setInit(true);
        }
    };
    if (!init) {
        setConsentDataFromCookie();
    }

    window.addEventListener('cookieChange', () => {
        setConsentDataFromCookie();
    });

    const showCookieLayer = () => {
        window.showCookieLayer();
    };

    return (
        <div className="page-privacy-policy redesign">
            <Header login={storage.get('access_token')} />
            <section className="content-wrapper">
                <div>
                    <h1 className="main-headline text-center">Datenschutz</h1>
                    <h2 className="text-center">Datenschutzhinweise der AurumTours GmbH</h2>
                    <p className="text-center">
                        Die entsprechenden Pflichtangaben (Vorab-Informationen) der AurumTours GmbH zur Datenspeicherung
                        sowie Ihrem Widerrufs-, Auskunft-, Löschungs- und Beschwerderecht gemäß Ziffer 13 EU-DSGVO
                        finden Sie{' '}
                        <a
                            href={`${window.$website}/unternehmen/datenschutz/vorabinformationen-datenschutz`}
                            target="_blank"
                            rel="noopener noreferrer">
                            hier
                        </a>
                        .
                    </p>
                </div>

                <article>
                    <h3>Allgemeines</h3>
                    <p>
                        An dieser Stelle möchten wir unsere Philosophie im Umgang mit persönlichen Daten, die Sie uns
                        beim Besuch unserer Website übermitteln, erläutern sowie einige grundlegende Hinweise zum
                        Datenschutz geben. Wir respektieren die Datenschutzrechte jedes Einzelnen. Unsere
                        Dienstleistungen stehen im Einklang mit den rechtlichen Datenschutzbestimmungen, die in der
                        EU-Datenschutzgrundverordnung (DSGVO), im neuen Bundesdatenschutzgesetz (BDSG-neu),
                        Telemediengesetz (TMG) und im Gesetz gegen den unlauteren Wettbewerb (UWG) geregelt sind.
                    </p>
                    <p>
                        Mit dem Besuch unserer Webseiten werden von uns automatisch verschiedene Informationen in den
                        jeweiligen Server-Logfiles erfasst. Hierzu gehören beispielsweise die Art und die Versionsnummer
                        Ihres Webbrowsers, Ihr verwendetes Betriebssystem, Informationen zu Ihrem verwendeten
                        Internetprovider und andere ähnliche Informationen. Diese Informationen fallen systembedingt bei
                        der Nutzung des Internets an und sind daher technisch zwingend notwendig, um einen
                        einwandfreien, reibungslosen und sicheren Betrieb einer Webseite zu gewährleisten. Ggf.
                        verwenden wir in anonymer Form diese Informationen zur Optimierung unseres Internetauftritts im
                        Rahmen statistischer Auswertungen.
                    </p>
                </article>

                <article>
                    <h3>Datenspeicherung, Datenverwendung und Datenweitergabe</h3>
                    <p>
                        Wir erfassen bei jeder Interaktion im AurumTours Kundenbereich bestimmte Daten, um die optimale
                        Nutzung unserer Dienste zu gewährleisten. Dies umfasst Datum und Zeitstempel Ihrer Interaktionen
                        sowie die besuchten Seiten/URLs und Ihre Interaktionen mit diesen Seiten. Diese Informationen
                        helfen uns, unsere Produkte und Dienstleistungen zu verbessern und sicherzustellen, dass Sie das
                        bestmögliche Nutzererlebnis erhalten. Zudem verwalten wir Ihre Daten, um mit Ihnen in Kontakt zu
                        treten und Ihnen relevante Informationen zukommen zu lassen. Dabei halten wir uns strikt an die
                        geltenden Datenschutzgesetze und behandeln Ihre Daten vertraulich.
                    </p>

                    <h4>Datenspeicherung</h4>
                    <p>
                        Die von Ihnen im Rahmen von der AurumTours GmbH (nachfolgend „AurumTours“ genannt) betriebenen
                        Vergleiche eingegebenen Daten werden von AurumTours, entsprechend der Rechtsgrundlage für die
                        Datenverarbeitung, wie beschrieben in Art. 6 Abs. 1 EU-DSGVO, erhoben, verarbeitet und für
                        Zwecke der Vergleichs- und Angebotserstellung sowie der weiteren Bearbeitung und Betreuung
                        gespeichert und genutzt. Selbstverständlich können Sie jederzeit mit Wirkung für die Zukunft von
                        Ihrem gesetzlichen Widerspruchsrecht hinsichtlich der Speicherung und Nutzung Ihrer persönlichen
                        und Ihnen eindeutig zugeordneten Daten Gebrauch machen. Wie Sie von Ihrem Widerspruchsrecht
                        Gebrauch machen können, erläutern wir Ihnen unter Punkt 8.1 (Widerspruchsrecht).
                    </p>

                    <h4>Datenverwendung</h4>
                    <p>
                        Neben der Speicherung und Nutzung zum Zwecke der Vergleichs- und Angebotserstellung, sowie der
                        weiteren Bearbeitung und Betreuung, nutzt AurumTours die eingegebenen Daten außerdem
                        ausschließlich in pseudonymisierter Form zu statistischen Zwecken, zu Zwecken der Marktforschung
                        und zur Gewinnung von Erkenntnissen zur Verbesserung des eigenen Internetauftrittes.
                        Selbstverständlich können Sie von Ihrem gesetzlichen Widerspruchsrecht hinsichtlich
                        statistischer Zwecken, zu Zwecken der Marktforschung und zur Gewinnung von Erkenntnissen zur
                        Verbesserung des eigenen Internetauftrittes mit Wirkung für die Zukunft Gebrauch machen. Wie Sie
                        von Ihrem Widerspruchsrecht Gebrauch machen können, erläutern wir Ihnen unter Punkt 8.1
                        (Widerspruchsrecht).
                    </p>

                    <h4>Datenweitergabe</h4>
                    <p>
                        AurumTours legt großen Wert darauf, dass in keinem Fall eine Weitergabe Ihrer Daten an
                        unbeteiligte Dritte ohne Ihre aktive Einwilligung stattfindet, es sei denn, wir sind oder wir
                        werden hierzu in irgendeiner Form gesetzlich verpflichtet. Das wäre beispielsweise dann der
                        Fall, wenn wir im Rahmen der Verfolgung und Aufklärung von Straftaten zur Herausgabe der Daten
                        verpflichtet sind bzw. verpflichtet werden. Ansonsten erfolgt eine Weitergabe Ihrer Daten
                        ausschließlich auf Grundlage Ihrer expliziten Einwilligung und auch nur an die von Ihnen
                        ausgewählte Gesellschaft und hier wiederum ausschließlich zum Zwecke der Vertragsabwicklung. Wir
                        geben Ihre Daten bei Zustandekommen eines Vertrags an externe Dienstleister weiter (z.B.
                        Fluggesellschaften, Hotels), um Ihnen die gebuchten Leistungen zur Verfügung zu stellen. Zur
                        Erfüllung des Vertrages müssen wir die Daten aller Reisenden erheben. Bitte bedenken Sie, dass
                        Sie bei Buchung zur Weitergabe dieser Daten berechtigt sein müssen und es in Ihrer Pflicht liegt
                        die Reisenden über unsere Datenschutzbestimmungen zu informieren. Sie können das uns einmal
                        gegebene Einverständnis jederzeit mit Wirkung für die Zukunft widerrufen und/oder der künftigen
                        Verwendung Ihrer Daten widersprechen. Wie Sie von Ihrem Widerspruchsrecht Gebrauch machen
                        können, erläutern wir Ihnen unter Punkt 8.1 (Widerspruchsrecht).
                    </p>
                </article>

                <article>
                    <h3>Datensicherheit</h3>
                    <p>
                        Sobald Sie persönliche Daten in die von uns betriebenen Reise-Vergleichsmodulen eingeben oder
                        wenn Sie Ihre persönlichen Daten im zentralen Kundenbereich eingegeben und gespeichert haben und
                        sich anmelden, findet diese Kommunikation ab diesem Zeitpunkt verschlüsselt statt. Wir verbinden
                        Sie mit unserem Sicherheitsserver, so dass die Daten von niemandem mitgelesen werden können.
                        Hierzu setzen wir entsprechende SSL-Verschlüsselungsverfahren ein, so dass Ihre Daten
                        ausschließlich im abgesicherten "https-Modus" übertragen werden. Dieses Verfahren ist Standard
                        und wird u.a. vom Bundesamt für Sicherheit in der Informationstechnik (BSI) empfohlen. Zu Ihrer
                        eigenen Sicherheit empfehlen wir Ihnen, ausschließlich die jeweils aktuellen Browserversionen
                        und Virenscanner zu verwenden. Sie erkennen die eingeschaltete Verschlüsselung am aktivierten
                        Schloss-Symbol unten in der Statuszeile des Browsers bzw. direkt oberhalb des Vergleichsmoduls
                        oder direkt neben der jeweiligen URL von AurumTours. Wir schützen unsere Server und damit Ihre
                        Daten mit den modernsten Sicherheitsprogrammen und Firewalls, die einen unbefugten
                        Zugangsversuch bereits von Beginn an unterbinden.
                    </p>
                </article>

                <article>
                    <h3>Cookies</h3>
                    <p>
                        Im Rahmen der ständigen Verbesserung des Angebotes für unsere Benutzer können ggf. weitere
                        Trackingtechnologien von Drittanbietern und uns eingesetzt werden, welche anonymisierte und
                        temporäre "Session-Cookies" als auch "Persistente Cookies" verwenden. Cookies sind meistens
                        kleine Textdateien, die ein Webserver bei einem Aufruf einer Webseite auf Ihr Gerät überträgt.
                    </p>
                    <p>
                        "Session Cookies" (temporäre Cookies) werden nicht dauerhaft auf dem jeweiligen Gerät, mit dem
                        Sie unsere Webseite besuchen, gespeichert und mit dem Schließen des Browsers automatisch
                        gelöscht. Diese Cookies können u.a. Informationen über den von Ihnen verwendeten Browser, die
                        Bildschirmauflösung, das verwendete Betriebssystem aber auch andere individuelle Informationen
                        enthalten. Daher können diese Cookies auch dazu genutzt werden, um Ihnen das Navigieren auf
                        unserer Webseite zu erleichtern und/oder um die korrekte Darstellung auf der jeweiligen Webseite
                        zu gewährleisten.
                    </p>
                    <p>
                        "Persistente Cookies" oder auch "permanente Cookies" hingegen speichern anonyme Informationen
                        auf dem jeweiligen Gerät und stehen auch nach dem Schließen des Browsers weiterhin zur
                        Verfügung. Jedes dieser Cookies ist mit einem entsprechenden "Verfalls-"/Gültigkeitsdatum
                        versehen, zu dem dann dieses Cookie automatisch gelöscht wird. Der Zweck des Einsatzes dieser
                        Cookies besteht u.a. darin, anonyme Statistiken über die Nutzung unserer Internetpräsenzen zu
                        erstellen. Die Statistiken können u.a. dazu dienen, zu erkennen, an welchen Stellen wir unsere
                        Web-Seiten noch optimieren müssen, damit sie für Sie einfacher nutzbar werden.
                    </p>
                    <p>
                        Beide Cookie-Arten sind anonym. Es erfolgt keine Einzelprofilbildung über Ihr Nutzungsverhalten.
                        Sie haben jederzeit die Möglichkeit die Speicherung von Cookies zu unterbinden, indem Sie dies
                        in Ihren Browsereinstellungen konfigurieren. Wie Sie die jeweiligen Einstellungen zum
                        Deaktivieren der Cookies vorzunehmen haben, lesen Sie bitte in den jeweiligen Hilfen zu Ihrem
                        Browser nach. Bitte beachten Sie, dass durch die Deaktivierung der Cookies, neben ggf.
                        auftretenden Darstellungs- und Navigationsproblemen, es zu erheblichen Einschränkungen der
                        Funktionalität unserer Webseite kommen kann, sodass eine Funktionstüchtigkeit der Webseite,
                        speziell bzgl. der Übermittlung von Buchungsaufträgen, ohne die Speicherung von Cookies nicht
                        gewährleistet werden kann.
                    </p>
                    <p>
                        Wichtig für Sie: Die von uns in den Cookies erfassten Daten werden nicht an Dritte
                        weitergereicht oder ohne Ihre Einwilligung mit Ihren personenbezogenen Daten verknüpft. Auch ist
                        eine eindeutige persönliche Identifikation anhand der erfassten Daten durch Drittanbieter in den
                        Cookies nicht möglich bzw. nicht vorgesehen.
                    </p>
                    <h4>Cookie-Kategorien</h4>
                    {consentData.cookieData && (
                        <>
                            <p>Ihr aktueller Zustand: ({consentData.enabledSettings})</p>
                            <p>
                                Ihre Einwilligungs-ID: {consentData.uuid} <br />
                                Eingewilligt am: {consentData.dateString}
                            </p>
                        </>
                    )}
                    <table className="consent-table">
                        <thead>
                            <tr>
                                <td>Typ</td>
                                <td>Cookie-Beschreibung</td>
                                <td>Cookie-Präferenzen anpassen</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Notwendige Cookies</td>
                                <td>
                                    "Session Cookies" (temporäre Cookies) werden nicht dauerhaft auf dem jeweiligen
                                    Gerät, mit dem Sie unsere Webseite besuchen, gespeichert und mit dem Schließen des
                                    Browsers automatisch gelöscht. Diese Cookies können u.a. Informationen über den von
                                    Ihnen verwendeten Browser, die Bildschirmauflösung, das verwendete Betriebssystem
                                    aber auch andere individuelle Informationen enthalten. Daher können diese Cookies
                                    auch dazu genutzt werden, um Ihnen das Navigieren auf unserer Webseite zu
                                    erleichtern und/oder um die korrekte Darstellung auf der jeweiligen Webseite zu
                                    gewährleisten.
                                </td>
                                <td>
                                    <div className="consent-status-table-cell">
                                        <div className="head">
                                            Status der Nutzung:
                                            <br />
                                            <br />
                                            {consentData.cookieData?.necessary
                                                ? `Ihre Einwilligungs-ID: ${consentData.uuid}`
                                                : 'Keine notwendigen Cookies gesetzt'}
                                        </div>
                                        <div>
                                            <Button label="Cookie Präferenzen anpassen" handleClick={showCookieLayer} />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>Analytische Cookies</td>
                                <td>
                                    In der Kategorie "Analytisch" finden sich Cookies wieder, die es uns zusammen mit
                                    den dazugehörigen Technologien erlauben das Nutzungsverhalten von Benutzern auf
                                    kundenbereich.aurumtours.de zu analysieren und auszuwerten. Die daraus gewonnenen
                                    Erkenntnisse dienen dazu unsere Services nutzerorientiert weiterzuentwickeln und
                                    entsprechend zu verbessern. Ein unmittelbarer, aktiver Einsatz der gewonnenen Daten
                                    erfolgt nicht.
                                    <br />
                                    <br />
                                    Google Analytics
                                    <br />
                                    <br />
                                    Google Tag Manager
                                    <br />
                                    <br />
                                    (Nutzungsbedingungen: https://policies.google.com/terms <br />
                                    Datenschutzerklärung: https://policies.google.com/privacy)
                                </td>
                                <td>
                                    <div className="consent-status-table-cell">
                                        <div className="head">
                                            Status der Nutzung:
                                            <br />
                                            <br />
                                            {consentData?.cookieData?.analytics_storage === 'granted'
                                                ? `Ihre Einwilligungs-ID: ${consentData.uuid}`
                                                : 'Keine analytischen Cookies gesetzt'}
                                        </div>
                                        <div>
                                            <Button label="Cookie Präferenzen anpassen" handleClick={showCookieLayer} />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </article>

                <article>
                    <h3>Trackingtechnologien</h3>
                    <h4>Google Marketing Platform: Google Analytics</h4>
                    <p>
                        Diese Webseite benutzt Google Analytics, einen Webanalysedienst der von Google Inc., 1600
                        Amphitheatre Parkway, Mountain View, CA 94043, USA betrieben wird ("Google"). Google Analytics
                        verwendet sog. "Cookies", Textdateien, die auf Ihrem Computer gespeichert werden und die eine
                        Analyse der Benutzung der Webseite durch Sie ermöglichen. Die durch die Cookies erzeugten
                        Informationen über Ihre Benutzung dieser Webseite werden in der Regel an einen Server von Google
                        in den USA übertragen und dort gespeichert. Aufgrund der Aktivierung der IP-Anonymisierung auf
                        diesen Webseiten, wird Ihre IP-Adresse von Google jedoch innerhalb von Mitgliedstaaten der
                        Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen
                        Wirtschaftsraum zuvor gekürzt. Nur in Ausnahmefällen wird die volle IP-Adresse an einen Server
                        von Google in den USA übertragen und dort gekürzt. Im Auftrag des Betreibers dieser Webseite
                        wird Google diese Informationen benutzen, um Ihre Nutzung der Webseite auszuwerten, um Reports
                        über die Webseitenaktivitäten zusammenzustellen und um weitere mit der Webseitennutzung und der
                        Internetnutzung verbundene Dienstleistungen gegenüber dem Webseitenbetreiber zu erbringen. Die
                        im Rahmen von Google Analytics von Ihrem Browser übermittelte IP-Adresse wird nicht mit anderen
                        Daten von Google zusammengeführt.
                    </p>
                    <p>
                        Diese Website nutzt die Funktion "demografische Merkmale" von Google Analytics. Dadurch können
                        Berichte erstellt werden, die Aussagen zu Alter, Geschlecht und Interessen der Seitenbesucher
                        enthalten. Diese Daten stammen aus interessenbezogener Werbung von Google sowie aus
                        Besucherdaten von Drittanbietern. Diese Daten können keiner bestimmten Person zugeordnet werden.
                        Ihre DSGVO-konforme Erlaubnis für die Nutzung von Google Analytics haben Sie über das Cookie
                        Consent Tool gegeben. Sie können diese Funktion jederzeit über die Anzeigeneinstellungen in
                        Ihrem Google-Konto deaktivieren oder die Erfassung Ihrer Daten durch Google Analytics wie im
                        Punkt "Widerspruch gegen Datenerfassung" dargestellt generell untersagen.
                    </p>
                    <p>
                        Sie können die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer
                        Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall
                        gegebenenfalls nicht sämtliche Funktionen dieser Webseite vollumfänglich werden nutzen können.
                        Sie können darüber hinaus die Erfassung der durch das Cookie erzeugten und auf Ihre Nutzung der
                        Webseite bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die Verarbeitung dieser Daten
                        durch Google verhindern, indem sie unter dem folgenden Link (
                        <a
                            href="https://tools.google.com/dlpage/gaoptout?hl=de"
                            target="_blank"
                            rel="noopener noreferrer">
                            https://tools.google.com/dlpage/gaoptout?hl=de
                        </a>
                        ) die verfügbaren Browser-Plugin zur Deaktivierung von Google Analytics herunterladen und
                        installieren. Dieses müssen Sie für jeden verwendeten Browser auf Ihren Geräten separat
                        durchführen.
                    </p>
                    <p>
                        Neben dem oben erwähnten Browser-Plugin zur Deaktivierung von Google Analytics besteht
                        alternativ und/oder zusätzlich die Möglichkeit auch ein sogenanntes Opt-Out-Cookie in Ihrem
                        verwendeten Browser setzen zu lassen. Bitte beachten Sie, dass Sie hierfür JavaScript aktiviert
                        haben müssen. Zum Setzen des Opt-Out-Cookies verwenden Sie bitte folgenden Link:
                    </p>
                    <p>[Google Analytics deaktivieren]</p>
                    <p>
                        Mit Setzen dieses Cookies wird die Erfassung durch Google Analytics nur für diesen einen Browser
                        mit Wirkung für die Zukunft verhindert und das auch nur, solange das entsprechende Cookie in
                        Ihrem Browser installiert bleibt. Wir weisen Sie darauf hin, dass auf dieser Webseite Google
                        Analytics um den Code "gat. anonymizeIp();" erweitert wurde, um eine anonymisierte Erfassung von
                        IP-Adressen (sog. IP-Masking) zu gewährleisten. Weitere Informationen zum Thema Datenschutz von
                        Google Analytics finden Sie unter{' '}
                        <a
                            href="https://www.google.com/intl/de/analytics/privacyoverview.html"
                            target="_blank"
                            rel="noopener noreferrer">
                            www.google.com/intl/de/analytics/privacyoverview.html
                        </a>
                    </p>

                    <h4>Google Tag Manager</h4>
                    <p>
                        Diese Webseite benutzt den Google Tag Manager, einen Tag Managementdienst der von Google Inc.,
                        1600 Amphitheatre Parkway, Mountain View, CA 94043, USA betrieben wird ("Google"). Tags sind
                        kleine Codeelemente, die wir ggf. auf den von uns betriebenen Webseiten einsetzen, um unter
                        anderem den Traffic und das Besucherverhalten unserer Nutzer zu messen, die Auswirkung von
                        Online-Werbung und sozialen Kanälen zu erfassen, um Remarketing und die Ausrichtung auf
                        Zielgruppen betreiben zu können und um unsere Website zu testen und zu optimieren. Weiter
                        stellen wir durch den Einsatz dieses Tools sicher, dass wir keine redundanten oder falsch
                        angewendeten Tags einsetzen, die dann ggf. u.a. zu einer Verfälschung unserer Messungen führen
                        könnten und darauf basierend ggf. höhere Kosten durch fehlende bzw. fehlerbehafte Daten auf
                        unserer Seite zur Folge hätten. Auch erhalten wir mit diesem Tool ein Werkzeug, welches uns ohne
                        großen Zeitaufwand ermöglicht, neue Tags hinzuzufügen, um wichtige Marketing- und
                        Analyseschritte zu beschleunigen.
                    </p>
                    <p>
                        Der Google Tag Manager selbst, in dem man die Tags implementiert hat, ist eine cookielose Domain
                        und erfasst keine personenbezogenen Daten. Das Tool sorgt lediglich dafür, dass eine Auslösung
                        anderer "Tracking"-Tags erfolgt, die ihrerseits unter Umständen Daten erfassen. Somit greift der
                        Google Tag Manager nicht auf diese Daten zu, sondern "stößt" lediglich diese "Verarbeitung" an.
                        Wenn Sie in Ihrem Browse auf Domain- oder Cookie-Ebene bereits eine Deaktivierung von den
                        betreffenden Anbietern vorgenommen haben, bleibt diese Deaktivierung selbstverständlich auch für
                        diese betreffenden Tracking-Tags bestehen, die mit Hilfe des Google Tag Manager implementiert
                        worden sind.
                    </p>
                    <p>
                        Weitere Informationen zu den Nutzungs- und den Datenschutzrichtlinien für dieses Produkt finden
                        sie hier:{' '}
                        <a
                            href="https://marketingplatform.google.com/about/analytics/tag-manager/use-policy/"
                            target="_blank"
                            rel="noopener noreferrer">
                            https://marketingplatform.google.com/about/analytics/tag-manager/use-policy/
                        </a>{' '}
                        und{' '}
                        <a
                            href="https://www.google.com/intl/de/policies/privacy/"
                            target="_blank"
                            rel="noopener noreferrer">
                            www.google.com/intl/de/policies/privacy/
                        </a>
                    </p>
                </article>

                <article>
                    <h3>Datenverwendung bei Nutzung von Leistungen</h3>
                    <h4>Buchung einer Reise</h4>
                    <p>
                        Informationen zu Ihrer Reisebuchung werden an die bei der jeweiligen Buchung beteiligten Hotels,
                        Airlines sowie Anbieter für die technische Abwicklung weitergegeben. Anbieter für die technische
                        Abwicklung sind u.a.: CHECK24 Vergleichsportal Reise GmbH, Trappentreustraße 1 - 3, 80339
                        München.
                    </p>

                    <h4>Anmeldung im Kundenbereich</h4>
                    <p>
                        Bei der Anmeldung im Kundenbereich der AurumTours GmbH werden folgende persönliche Daten
                        erhoben: Ihre Buchungsnummer, der Nachname des ersten Reisenden sowie das Anreisedatum. Diese
                        Daten sind notwendig, um Sie eindeutig zu identifizieren und Ihnen den Zugang zu Ihrem
                        Buchungsprofil zu ermöglichen.
                    </p>

                    <h4>Flug- oder Hotelumbuchung</h4>
                    <p>
                        Für die Bearbeitung einer Flug- oder Hotelumbuchung müssen wir Ihre Buchungsdaten an den neuen
                        Leistungsträger übermitteln. Dies umfasst alle relevanten Informationen, die zur Abwicklung
                        Ihrer Umbuchung erforderlich sind. Ihre Daten werden ausschließlich für diesen Zweck genutzt und
                        streng vertraulich behandelt.
                    </p>

                    <h4>Notfallkontakt</h4>
                    <p>
                        Im Rahmen der Dienstleistung "Notfallkontakt" erfassen wir Ihren Namen, Ihre Telefonnummer und
                        Ihre E-Mail-Adresse, um im Notfall oder in dringend erforderlichen Umständen während Ihrer Reise
                        Kontakt mit Ihnen aufnehmen zu können. Diese Daten werden ausschließlich zu diesem Zweck
                        genutzt.
                    </p>

                    <h4>Digitale Reiseleitung</h4>
                    <p>
                        Sie können den exklusiven AurumTours Service der digitalen Reiseleitung über den Messenger
                        Dienst "WhatsApp" während Ihres Reiseaufenthaltes nutzen. Hierzu ist die Anmeldung über den in
                        Ihren Reiseunterlagen hinterlegten Link erforderlich. Mit Ihrer Zustimmung und der Anmeldung zur
                        digitalen Reiseleitung werden wir Sie über WhatsApp kontaktieren und für Fragen zur Verfügung
                        stehen. Entsprechend der Nutzungsbedingungen und Vorgaben von WhatsApp, liegen uns Ihre
                        personenbezogenen Daten (Name, Telefonnummer, Profilbild sowie der Nachrichtenverlauf) zur
                        Verarbeitung vor. Wir versichern, dass wir Ihre Daten ausschließlich verwenden, um den
                        angebotenen Service der digitalen Reiseleitung vollumfänglich zu gewährleisten und Ihnen auf
                        Ihre Fragen zu antworten. Die Rechtsgrundlage ist Art. 6 Abs.1 lit. (a) DSGVO.
                    </p>
                    <p>
                        Um die Datensicherheit zu gewährleisten, arbeitet WhatsApp mit der sogenannten Ende-zu-
                        Ende-Verschlüsselung. Damit diese Verschlüsselung sicher greift, empfehlen wir Ihnen stets die
                        aktuelle Version von WhatsApp auf Ihrem Mobiltelefon zu verwenden.
                    </p>
                    <p>
                        Sollten Sie die digitale Reiseleitung nicht mehr nutzen wollen, kann der Service direkt über
                        Ihren WhatsApp Messenger beendet werden. Pausieren Sie jederzeit den Empfang von WhatsApp
                        Nachrichten mit der Nachricht "Stop Service". Zum Löschen Ihrer Daten nach Artikel 17 DGSVO
                        senden Sie bitte eine Nachricht mit "Datenlöschung". Zur Erbringung des digitalen Dienstes
                        arbeiten wir mit Sinch.
                    </p>
                    <p>
                        Weitere Informationen rund um WhatsApp und dessen Einsatz bei unserem technischen
                        Kooperationspartner Sinch (firmierend unter MessengerPeople GmbH) finden Sie unter:
                    </p>

                    <p>
                        MessengerPeople GmbH <br />
                        Seidlstr. 8<br />
                        80335 München
                        <br />
                        +49 89 416173-180
                        <br />
                        <a href="mailto:info@MessengerPeople.com">info@MessengerPeople.com</a> <br />
                        www.sinch.com <br />
                        <br />
                        Die Datenschutzerklärung von MessengerPeople GmbH finden Sie hier:
                        <br />
                        <a href="https://www.sinch.com/de-de/privacy-policy/" target="_blank" rel="noreferrer">
                            https://www.sinch.com/de-de/privacy-policy/{' '}
                        </a>
                    </p>

                    <p>
                        Verantwortliche Anbieter der Messenger Dienste sind:
                        <br />
                        <br />
                        WhatsApp Ireland Limited
                        <br />
                        4 Grand Canal Square
                        <br />
                        Grand Canal Harbour
                        <br />
                        Dublin 2 <br />
                        Irland <br />
                        <br />
                        Die Datenschutzerklärung von WhatsApp finden Sie hier:
                        <br />
                        <a
                            href="https://www.whatsapp.com/legal#privacy-policy"
                            target="_blank"
                            rel="noopener noreferrer">
                            https://www.whatsapp.com/legal#privacy-policy
                        </a>
                    </p>

                    <h4>APIS Daten</h4>
                    <p>
                        Für die Erfüllung gesetzlicher Vorschriften und zur Sicherstellung Ihrer Reise benötigen wir die
                        Passdaten aller Reisenden. Diese Daten werden im Rahmen der Advanced Passenger Information
                        System (APIS) erfasst und an die jeweilige Fluggesellschaft sowie relevante Behörden
                        weitergegeben. Ihre Passdaten werden streng vertraulich behandelt und nur für diesen
                        spezifischen Zweck genutzt.
                    </p>

                    <h4>Zusatzleistungen</h4>
                    <p>
                        Bei der Buchung von Zusatzleistungen wie Transfers, Rail&Fly, Ausflügen oder
                        Sitzplatzreservierungen geben wir Ihre Buchungsdaten an den jeweiligen ausführenden Anbieter
                        weiter, um die Durchführung dieser Zusatzleistung zu gewährleisten.
                    </p>
                    <p>
                        Bei der Buchung eines Ausflugs können Sie freiwillig Ihre Telefonnummer angeben, damit der
                        Anbieter Sie bei Bedarf kontaktieren kann. Ihre Daten werden ausschließlich zur Erbringung der
                        jeweiligen Zusatzleistung genutzt und nicht für andere Zwecke verwendet.
                    </p>

                    <h4>ERGO Versicherungen</h4>
                    <p>
                        Reiseversicherungen werden angeboten von:
                        <br />
                        ERGO Reiseversicherung AG
                        <br />
                        Postfach 80 05 45
                        <br />
                        81605 München
                        <br />
                        Telefon: +49 (0) 89 4166 – 00
                        <br />
                        E-Mail: <a href="mailto:contact@reiseversicherung.de">contact@reiseversicherung.de</a>
                    </p>

                    <h4>Zahlungen</h4>
                    <p>
                        Die Zahlungsabwicklung erfolgt je nach Zahlungsart mit dem vom Kunden ausgewählten
                        Zahlungsmittel und wird über den Zahlungsanbieter CHECK24 Zahlungssysteme GmbH (Erika-Mann-Str.
                        62-66, 80636 München) abgewickelt. Ihre Zahlungsdaten werden sicher und vertraulich behandelt
                        und ausschließlich zur Abwicklung der Zahlungstransaktion verwendet.
                    </p>
                </article>

                <article>
                    <h3>Widerspruchs-, Auskunfts- und Löschungsrecht</h3>
                    <h4>Widerspruchsrecht</h4>
                    <p>
                        Wir weisen Sie darauf hin, dass es Ihnen gemäß Art. 21 DSGVO selbstverständlich frei steht,
                        sämtlich erteilte Einwilligungen jedweder Art und/oder der Speicherung Ihrer Daten entweder
                        selektiv oder vollständig mit Wirkungen für die Zukunft zu widerrufen.
                        <br />
                        Hierzu wenden Sie sich bitte per Brief an {COMPANY.NAME}, {COMPANY.ADDRESS_LEJ_STREET},{' '}
                        {COMPANY.ADDRESS_LEJ_CITY} oder per E-Mail an (info@aurumtours.de), ohne dass hierfür weitere
                        Kosten als die jeweiligen Übermittlungskosten nach den Basistarifen anfallen. Wichtig wäre uns,
                        dass Sie uns in Ihrer Mitteilung die Möglichkeit geben, dass wir Sie eindeutig identifizieren
                        können, indem Sie uns Ihren Namen, Ihre Anschrift und Ihr Geburtsdatum und einen Bezug zu einem
                        Vorgang, einem Angebot und/oder Abschluss nennen könnten.
                    </p>

                    <h4>Auskunftsrecht</h4>
                    <p>
                        Entsprechend Art. 15 DSGVO erteilen wir Ihnen sehr gern auf schriftlichen Wunsch durch unseren
                        Datenschutzbeauftragten Auskunft über Ihre bei uns gespeicherten Daten, die Ihnen zuordenbar
                        sind. Darüber hinaus haben Sie gemäß Art. 20 DSGVO das Recht die uns zur Verfügung gestellten
                        personenbezogenen Daten von uns in einem strukturierten und maschinenlesbaren Format zur
                        Verfügung gestellt zu bekommen.
                    </p>
                    <p>
                        In beiden Fällen richten Sie bitte Ihre Anfrage ausschließlich schriftlich an:
                        <br />
                        <br />
                        {COMPANY.NAME}
                        <br />
                        {COMPANY.ADDRESS_LEJ_STREET}
                        <br />
                        {COMPANY.ADDRESS_LEJ_CITY}
                        <br />
                        <br />
                        oder alternativ per E-Mail an <a href="mailto:info@aurumtours.de">info@aurumtours.de</a>
                    </p>
                    <p>
                        Bitte beachten Sie, dass eine Auskunft ausschließlich dann erteilt werden kann, wenn Sie uns
                        Ihren vollständigen Vor- und Nachnamen, Ihre aktuelle und ggf. auch alte Anschrift, Ihr
                        Geburtsdatum und Ihre E-Mailanschrift angeben. Diese Angaben dienen ausschließlich zum Abgleich
                        und stellen somit für Sie ein Schutz dar, dass nicht unberechtigte Dritte Ihre persönlichen
                        Daten erhalten können. Wünschenswert und hilfreich, aber nicht notwendig, wären darüber hinaus
                        auch etwaige Angebots-, Vorgangs- und/oder Vertragsnummern, die wir Ihnen mitgeteilt haben,
                        damit wir schneller die betreffenden Daten identifizieren können.
                    </p>

                    <h4>Löschungsrecht</h4>
                    <p>
                        Gemäß Art. 17 Abs. 1 DSGVO haben Sie das Recht die Löschung bzw. Sperrung Ihrer Daten bei uns zu
                        veranlassen. Bitte wenden Sie sich in dem Fall schriftlich, oder per Mail an unseren
                        Datenschutzbeauftragten. Hierzu richten Sie bitte Ihre Anfrage ausschließlich schriftlich an:
                        <br />
                        <br />
                        {COMPANY.NAME}
                        <br />
                        {COMPANY.ADDRESS_LEJ_STREET}
                        <br />
                        {COMPANY.ADDRESS_LEJ_CITY}
                        <br />
                        <br />
                        oder alternativ per E-Mail an <a href="mailto:info@aurumtours.de">info@aurumtours.de</a>
                    </p>
                    <p>
                        Bitte beachten Sie, dass eine Löschung gemäß Art. 17 DSGVO bzw. Einschränkung der Verarbeitung
                        gemäß Art. 18 DSGVO nur dann erfolgen kann, wenn Sie uns Ihren vollständigen Vor- und Nachnamen,
                        Ihre aktuelle und ggf. auch alte Anschrift, Ihr Geburtsdatum und Ihre E-Mailanschrift/-en
                        angeben. Wünschenswert und hilfreich, aber nicht notwendig, wären darüber hinaus auch etwaige
                        Angebots-, Vorgangs- und/oder Vertragsnummern, die wir Ihnen mitgeteilt haben, damit wir
                        schneller die betreffenden Daten identifizieren können. Diese Angaben dienen ausschließlich
                        dazu, um möglichst alle Daten von Ihnen bei uns zur Löschung bzw. Sperrung identifizieren zu
                        können. Andernfalls können wir nicht sicherstellen, dass wir Ihrem Wunsch nach Datenlöschung
                        bzw. Sperrung vollumfänglich nachkommen können.
                    </p>
                </article>

                <article>
                    <h3>Verlinkung</h3>
                    <p>
                        Sofern auf Verweisziele ("Links") direkt oder indirekt verwiesen wird, die außerhalb des
                        Verantwortungsbereichs AurumTours stehen, wird nur dann gehaftet, wenn AurumTours von den
                        Inhalten Kenntnis hat und es ihr technisch möglich und zumutbar gewesen wäre, die Nutzung im
                        Fall rechtswidriger Inhalte zu verhindern. Für darüberhinausgehende Inhalte und insbesondere für
                        Schäden, die aus der Nutzung oder Nichtnutzung solcher Art dargebotener Informationen entstehen,
                        haftet allein der Anbieter dieser Seiten, nicht derjenige, der über Links auf die jeweilige
                        Veröffentlichung lediglich verweist. AurumTours distanziert sich von Fremdinhalten jeglicher
                        Art.
                    </p>
                </article>

                <article>
                    <h3>Einwilligungserklärungen</h3>
                    <p>
                        Ich willige darin ein, dass im Rahmen einer Online-Buchung einer Reiseleistung die vollständige
                        IP-Adresse meines Computers und das entsprechende Datum und die Uhrzeit an AurumTours
                        übermittelt und von dieser gespeichert werden darf, um mich und AurumTours vor einem Missbrauch
                        der Daten zu schützen.
                        <br />
                        <br />
                        Sämtliche Einwilligungserklärungen können Sie formlos per Brief an
                        <br />
                        <br />
                        {COMPANY.NAME}
                        <br />
                        {COMPANY.ADDRESS_LEJ_STREET}
                        <br />
                        {COMPANY.ADDRESS_LEJ_CITY}
                        <br />
                        <br />
                        oder alternativ per E-Mail an <a href="mailto:info@aurumtours.de">info@aurumtours.de</a>
                        <br />
                        <br />
                        mit Wirkung für die Zukunft widerrufen.
                    </p>
                </article>
            </section>
            <Footer />
        </div>
    );
};
export default PrivacyPolicy;
